module.exports = __webpack_public_path__ + "static/media/social_STAKE.c733837f.jpg";